import dynamic from 'next/dynamic';
import { useState, useCallback } from 'react';

// Import the Snackbar component with SSR disabled
const ClientSnackbar = dynamic(() => import('../components/ClientSnackbar'), {
  ssr: false,
});

const useSnackbar = () => {
  const [snackbar, setSnackbar] = useState(false);
  const [customOnClose, setCustomOnClose] = useState(null);

  const handleClose = useCallback(
    (event, reason) => {
      // Always close the snackbar regardless of reason
      setSnackbar(false);

      // Only call custom onClose for non-clickaway reasons
      if (reason !== 'clickaway' && customOnClose) {
        customOnClose(event, reason);
      }
    },
    [customOnClose],
  );

  const renderSnackbar = ({
    color,
    message,
    duration,
    sx,
    vertical,
    onClose,
    'data-cy': dataCy,
  }) => {
    // Store the custom onClose callback
    if (onClose !== customOnClose) {
      setCustomOnClose(() => onClose);
    }

    return (
      <ClientSnackbar
        anchorOrigin={{
          vertical,
          horizontal: 'center',
        }}
        open={snackbar}
        message={message}
        sx={{
          '.MuiPaper-root': {
            backgroundColor: color,
            ...sx,
          },
        }}
        autoHideDuration={duration || 1000}
        onClose={handleClose}
        severity="error"
        data-cy={dataCy}
      />
    );
  };

  return [renderSnackbar, setSnackbar];
};

export default useSnackbar;
